<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="11.5" r="10.5" stroke="#000"/>
  <path stroke="#000" d="M11.5 5v8h6"/>
</svg>
